import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  NumberField,
  EditButton,
  DateField,
  Resource,
  Show,
  Filter,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  NumberInput,
  AutocompleteInput,
} from "react-admin";
import { FUNCTIONAL_UNIT, DEFAULT_TYPES_ARTICLE_CATEGORY } from "../consts";
import VersionedList, { DbVersionFilterInput, DbVersionField, DbVersionInput } from "../components/DbVersion";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
    <DbVersionFilterInput alwaysOn />
  </Filter>
);

const ArticleCategoryList = (props) => {
  return (
    <VersionedList {...props} filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="name" />
          <TextField source="id" />
          <DbVersionField />
          <ReferenceField source="group.id" reference="articleGroup" label="Article group">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="functionalUnit" label="Functional unit" />
          <TextField source="Default_article_manufacturing_loss_rate" label="Manufacturing loss rate" />
          <TextField source="Default_article_manufacturing_loss_rate_source" label="Loss rate source" />
          <ReferenceField source="manufacturingOriginId" reference="origins" label="Manufacturing origin">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="originSource" label="Origin source" />
          <TextField source="type" label="Type" />
          <TextField source="ecobalyseTranslation" label="Ecobalyse" emptyText="-" />
          <NumberField source="average_weight_kg" label="Average weight (kg)" emptyText="-" />
          <TextField source="weight_justification" label="Weight justification" emptyText="-" />
          <NumberField source="repair_cost" label="Repair cost (€)" emptyText="-" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </VersionedList>
  );
};

const ShowArticleCategory = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="name" />
        <TextField source="id" />
        <ReferenceField source="group.id" reference="articleGroup" label="Article group">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="functionalUnit" label="Functional unit" />
        <TextField source="Default_article_manufacturing_loss_rate" label="Manufacturing loss rate" />
        <TextField source="Default_article_manufacturing_loss_rate_source" label="Loss rate source" />
        <ReferenceField source="manufacturingOriginId" reference="origins" label="Manufacturing origin">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="originSource" label="Origin source" />
        <TextField source="type" label="Type" />
        <TextField source="ecobalyseTranslation" label="Ecobalyse" emptyText="-" />
        <NumberField source="average_weight_kg" label="Average weight (kg)" emptyText="-" />
        <TextField source="weight_justification" label="Weight justification" emptyText="-" />
        <NumberField source="repair_cost" label="Repair cost (€)" emptyText="-" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateArticleCategory = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <DbVersionInput />
        <TextInput source="name" />
        <ReferenceInput source="group.id" reference="articleGroup" label="Article group">
          <SelectInput source="name" />
        </ReferenceInput>
        <SelectInput source="functionalUnit" choices={FUNCTIONAL_UNIT} label="Functional unit" />
        <NumberInput source="Default_article_manufacturing_loss_rate" label="Manufacturing loss rate" />
        <TextInput source="Default_article_manufacturing_loss_rate_source" label="Loss rate source" />
        <ReferenceInput
          source="manufacturingOriginId"
          reference="origins"
          label="Manufacturing origin"
        >
          <AutocompleteInput
            optionText="name"
            optionValue="id"
            fullWidth
            emptyText=""
            filterToQuery={searchText => ({ name: searchText })}
            resettable
          />
        </ReferenceInput>
        <TextInput source="originSource" label="Origin source" />
        <SelectInput source="type" choices={DEFAULT_TYPES_ARTICLE_CATEGORY} label="Type" />
        <TextInput source="ecobalyseTranslation" label="Ecobalyse" />
        <NumberInput source="average_weight_kg" label="Average weight (kg)" min={0} />
        <TextInput source="weight_justification" label="Weight justification" />
        <NumberInput source="repair_cost" label="Repair cost (€)" min={0} />
      </SimpleForm>
    </Create>
  );
};

const EditArticleCategory = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <DbVersionInput />
        <TextInput source="name" />
        <ReferenceInput source="group.id" reference="articleGroup" label="Article group">
          <SelectInput source="name" />
        </ReferenceInput>
        <SelectInput source="functionalUnit" choices={FUNCTIONAL_UNIT} label="Functional unit" />
        <NumberInput source="Default_article_manufacturing_loss_rate" label="Manufacturing loss rate" />
        <TextInput source="Default_article_manufacturing_loss_rate_source" label="Loss rate source" />
        <ReferenceInput
          source="manufacturingOriginId"
          reference="origins"
          label="Manufacturing origin"
        >
          <AutocompleteInput
            optionText="name"
            optionValue="id"
            fullWidth
            emptyText=""
            filterToQuery={searchText => ({ name: searchText })}
            resettable
          />
        </ReferenceInput>
        <TextInput source="originSource" label="Origin source" />
        <SelectInput source="type" choices={DEFAULT_TYPES_ARTICLE_CATEGORY} label="Type" />
        <TextInput source="ecobalyseTranslation" label="Ecobalyse" />
        <NumberInput source="average_weight_kg" label="Average weight (kg)" min={0} />
        <TextInput source="weight_justification" label="Weight justification" />
        <NumberInput source="repair_cost" label="Repair cost (€)" min={0} />
      </SimpleForm>
    </Edit>
  );
};

const articleCategoryResource = () => <Resource
  name="articleCategory"
  options={{ label: 'Article category', menuGroup: 'Bcome' }}
  list={ArticleCategoryList}
  create={CreateArticleCategory}
  edit={EditArticleCategory}
  show={ShowArticleCategory} />;

export default articleCategoryResource;
